import React, { useRef } from 'react';
import styled from 'styled-components';
import icons from '../../resources/icons/icomoon.svg';
import Error from '../elements/renderError';

export const Wrapper = styled.div`
  position: relative;
  overflow: visible;
  margin: ${props => props.wrapperMargin || '12px 0 0'};
  text-align: center;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

const Label = styled.label`
  width: 100%;
  height: 38px;
  color: ${props => props.theme.primary};
  position: absolute;
  top: 0px;
  font-size: 16px;
  font-weight: bold;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  color: ${props => props.theme.secondary};
  font-size: 14px;
  padding: 0px 10px;
  border: solid 1px ${props => props.borderColor || props.theme.primary};
  border-radius: ${props => props.borderRadius || '0'}
  background-color: transparent;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.secondary}
  }

  &:hover, &.active {
    border-color: ${props => props.theme.secondary}
  }
`;

const InputGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 360px;
  box-sizing: border-box;
  padding-top: ${props => (props.label ? '38px' : '0')};
  margin: ${props => props.inputMargin || '38px auto 0'};

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

const Icon = styled.svg`
  position: relative;
  top: -1px;
  width: 20px;
  height: 20px;
  margin-left: 10px;
  cursor: pointer;
  stroke: #646464;
  fill: #777;
`;

const TextInput = ({
  label,
  placeholder,
  input,
  type,
  meta = {},
  leftIcon = '',
  rightIcon = '',
  ...other
}) => {
  const inputRef = useRef();
  const inputGroupRef = useRef();

  const handleOnClickIcon = () => {
    inputRef.current.focus();
  };

  const handleOnInputFocus = () => {
    inputGroupRef.current.className = `${inputGroupRef.current.className} active`;
  };

  const handleOnInputBlur = () => {
    inputGroupRef.current.className = inputGroupRef.current.className.replace(
      ' active',
      ''
    );
  };

  return (
    <Wrapper {...other}>
      <InputGroup ref={inputGroupRef} {...other} label={label}>
        {label && <Label>{label}</Label>}
        {leftIcon && (
          <Icon onClick={handleOnClickIcon}>
            <use xlinkHref={`${icons}#${leftIcon}`} />
          </Icon>
        )}
        <Input
          ref={inputRef}
          placeholder={placeholder || label}
          {...other}
          {...input}
          type={type}
          onFocus={handleOnInputFocus}
          onBlur={handleOnInputBlur}
        />
        {rightIcon && (
          <Icon onClick={handleOnClickIcon}>
            <use xlinkHref={`${icons}#${rightIcon}`} />
          </Icon>
        )}
      </InputGroup>
      <Error meta={meta} />
    </Wrapper>
  );
};

export default TextInput;
